export type SocialIcon = React.FC<{
  className?: string;
}>;

export { default as GitHubIcon } from './GitHubIcon';
export { default as MastodonIcon } from './MastodonIcon';
export { default as RssIcon } from './RssIcon';
export { default as ThreadsIcon } from './ThreadsIcon';
export { default as TwitchIcon } from './TwitchIcon';
export { default as TwitterIcon } from './TwitterIcon';
export { default as YouTubeIcon } from './YouTubeIcon';
